import React from 'react'
import AboutUsSection from '../../components/about/AboutUS'
import { useSelector } from 'react-redux'
import Rimg1 from "../../assest/Residentails-1.png";
import Rimg2 from "../../assest/Residental-2.png";
import Rimg3 from "../../assest/Residenatl-3.png";
import ServicesCard from '../../components/home/ServicesCard';
import FaqSection from '../../components/about/FAQ';
import ServicesSubPages from '../residential/ServicesSubPages';

const ProjectSupervision = () => {

    const language = useSelector((state) => state.language.language) || 'gb'

    const translations = {
        gb: {
            heading: "Project Supervision ",
            buttonText: "Get In Touch",
            aboutHeading: "About Our Project Supervision",
            aboutText: `At Etihad Gharbia Contracting Company, our project supervision services ensure your construction projects are delivered on time, within budget, and to the highest quality standards. Our team of experienced supervisors provides comprehensive oversight throughout all project phases, from planning to completion.

We implement rigorous quality control measures, monitor progress against milestones, and maintain strict compliance with safety regulations and building codes. Our proactive approach identifies potential issues early, preventing costly delays and ensuring smooth project execution.`,
            includedHeading: "Our Project Supervision Services",
            customizedHeading: "Why Choose Our Supervision Services"
        },
        sa: {
            heading: "خدمات إشراف المشاريع",
            buttonText: "تواصل معنا",
            aboutHeading: "حول خدمات الإشراف لدينا",
            aboutText: `في شركة اتحاد غربيا للمقاولات، تضمن خدمات إشراف المشاريع لدينا تسليم مشاريعكم في الوقت المحدد، ضمن الميزانية، وبأعلى معايير الجودة. يوفر فريق المشرفين ذوي الخبرة لدينا إشرافًا شاملاً خلال جميع مراحل المشروع، من التخطيط حتى الانتهاء.

ننفذ إجراءات صارمة لمراقبة الجودة، ونراقب التقدم مقابل المعالم الرئيسية، ونحافظ على الالتزام الصارم بأنظمة السلامة ومواصفات البناء. يحدد نهجنا الاستباقي المشكلات المحتملة مبكرًا، مما يمنع التأخيرات المكلفة ويضمن تنفيذًا سلسًا للمشروع.`,
            includedHeading: "خدمات إشراف المشاريع لدينا",
            customizedHeading: "لماذا تختار خدمات الإشراف لدينا"
        },
        fr: {
            heading: "Services de Supervision de Projet",
            buttonText: "Contactez-nous",
            aboutHeading: "À propos de notre supervision de projet",
            aboutText: `Chez Etihad Gharbia Contracting Company, nos services de supervision de projet garantissent que vos projets de construction sont livrés à temps, dans le budget et selon les normes de qualité les plus élevées. Notre équipe de superviseurs expérimentés fournit une surveillance complète à toutes les phases du projet, de la planification à l'achèvement.

Nous mettons en œuvre des mesures rigoureuses de contrôle qualité, surveillons les progrès par rapport aux jalons et maintenons une stricte conformité avec les réglementations de sécurité et les codes du bâtiment. Notre approche proactive identifie les problèmes potentiels tôt, évitant des retards coûteux et assurant une exécution fluide du projet.`,
            includedHeading: "Nos services de supervision de projet",
            customizedHeading: "Pourquoi choisir nos services de supervision"
        },
        de: {
            heading: "Projektüberwachungsdienstleistungen",
            buttonText: "Kontaktieren Sie uns",
            aboutHeading: "Über unsere Projektüberwachung",
            aboutText: `Bei Etihad Gharbia Contracting Company stellen unsere Projektüberwachungsdienstleistungen sicher, dass Ihre Bauprojekte termingerecht, innerhalb des Budgets und nach höchsten Qualitätsstandards geliefert werden. Unser Team erfahrener Aufsichtspersonen bietet umfassende Überwachung während aller Projektphasen, von der Planung bis zur Fertigstellung.

Wir implementieren rigorose Qualitätskontrollmaßnahmen, überwachen den Fortschritt gegenüber Meilensteinen und halten uns strikt an Sicherheitsvorschriften und Bauvorschriften. Unser proaktiver Ansatz identifiziert potenzielle Probleme frühzeitig, verhindert kostspielige Verzögerungen und gewährleistet einen reibungslosen Projektablauf.`,
            includedHeading: "Unsere Projektüberwachungsdienste",
            customizedHeading: "Warum unsere Aufsichtsdienste wählen"
        }
    }

    const t = translations[language] || translations.gb

    return (
        <>
            <AboutUsSection
                heading={t.heading}
                buttonText={t.buttonText}
                language={language}
            />
            <ServicesSubPages
                aboutHeading={t.aboutHeading}
                aboutText={t.aboutText}
                images={[Rimg1, Rimg2, Rimg3]}
                includedHeading={t.includedHeading}
                includedItems={[
                    language === 'sa' ? "الإشراف اليومي على موقع البناء" : "Daily construction site supervision",
                    language === 'sa' ? "مراقبة الجودة وضمانها" : "Quality control and assurance",
                    language === 'sa' ? "إدارة التقدم والجدول الزمني" : "Progress and schedule management",
                    language === 'sa' ? "التنسيق بين المقاولين والموردين" : "Contractor and supplier coordination",
                    language === 'sa' ? "مراقبة السلامة والامتثال" : "Safety monitoring and compliance",
                    language === 'sa' ? "إدارة التغييرات في المشروع" : "Project change management",
                    language === 'sa' ? "التوثيق وإعداد التقارير" : "Documentation and reporting",
                    language === 'sa' ? "التفتيش النهائي وتسليم المشروع" : "Final inspection and project handover"
                ]}
                customizedHeading={t.customizedHeading}
                customizedItems={[
                    language === 'sa' ? "فريق إشراف معتمد وذو خبرة" : "Certified and experienced supervision team",
                    language === 'sa' ? "نهج استباقي لمنع المشاكل" : "Proactive approach to problem prevention",
                    language === 'sa' ? "أدوات وإجراءات إشراف حديثة" : "Modern supervision tools and procedures",
                    language === 'sa' ? "الالتزام الصارم بمعايير الجودة" : "Strict adherence to quality standards",
                    language === 'sa' ? "تواصل واضح وشفاف" : "Clear and transparent communication",
                    language === 'sa' ? "إدارة فعالة للمخاطر" : "Effective risk management",
                    language === 'sa' ? "فهم عميق للوائح السعودية" : "Deep understanding of Saudi regulations",
                    language === 'sa' ? "تركيز على تحقيق رؤية 2030" : "Focus on achieving Vision 2030 objectives"
                ]}
            />
            <ServicesCard showHeading={false} showParagraph={false} />
            <FaqSection />
        </>
    )
}

export default ProjectSupervision